import React, { useEffect, useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import Video from "../components/common/Video";
import ContactWays from "../components/layout/ContactWays";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../hooks/useRouteInfo";

const WorkWithUsPage = (props) => {
  const { metaData } = useRouteInfo();

  return (
    <div className="container_1 py-8">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <div className="mb-6 mt-6">
        <h1 className="title"> {metaData?.h1}</h1>
        <p className="desc">
          اگر فردی نتیجه‌گرا و خلاق هستید و در کوله‌بار تجربهٔ شما ردپای انگیزهٔ
          پیشرفت و یادگیری به چشم می‌خورد، شاید بخواهید حضور حرفه‌ای در یک تیم
          پویا را تجربه کنید. در فضای ۱۹۲۴ همه چیز در راستای بهینه‌سازی همیشگی
          پیش می‌رود. ارزش‌های ما در این تیم عبارتند از:
        </p>
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative dashed-right">
        <h4 className="text-[22px] font-bold pt-2">فرهنگ پویا و پرانرژی</h4>
        <p className="desc">
          افراد در تیم‌ها برای ۱۹۲۴ مثل اعضا و ارگان‌ها هستند، قلب این پیکر
          پویایی همیشگی و جمعی ماست. ما محیط کاری همکاری‌کننده، فراگیر و
          نوآورانه‌ای داریم که ایده‌های همه اعضا ارزشمند است. به فرهنگ احترام
          متقابل، یادگیری مستمر و نشاط باور داریم.
        </p>
        <img
          src="/work (1).jpg"
          className="w-full  object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative  dashed-right">
        <h4 className="text-[22px] font-bold pt-2">رشد در مسیر شغلی</h4>
        <p className="desc">
          ما به رشد حرفه‌ای شما متعهدیم. در۱۹۲۴ فرصت‌های فراوانی برای پیشرفت
          شغلی، برنامه‌های آموزشی و منتورینگ وجود دارد. ما از کارکنان خود در
          مسیر بهبود و تعالی مستمر حمایت می‌کنیم.
        </p>
        <img
          src="/work (4).jpg"
          className="w-full  object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative dashed-right">
        <h4 className="text-[22px] font-bold pt-2">همکاری نوآورانه در تیم</h4>
        <p className="desc">
          ما به قدرت تیم‌ورک باور داریم. در ۱۹۲۴ شما فرصت همکاری با حرفه‌ای‌های
          با استعداد از زمینه‌های مختلف را خواهید داشت. ما تشویق به همکاری
          بین‌وظیفه‌ای برای دستیابی به بهترین نتایج می‌کنیم. پلتفرم ما بر اساس
          فناوری‌های پیشرفته ساخته شده و ما همیشه به دنبال روش‌های جدید برای
          بهبود خدمات خود هستیم. اگر به فناوری و نوآوری علاقه‌مند هستید، در ۱۹۲۴
          جای شماست.
        </p>
        <img
          src="/work (3).jpg"
          className="w-full  object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <div className="mb-6 mt-6 pr-4 yellow-circle relative">
        <h4 className="text-[22px] font-bold pt-2">تعادل بین کار و زندگی</h4>
        <p className="desc">
          ما اهمیت تعادل بین کار و زندگی را درک می‌کنیم. سیاست‌های ما طراحی
          شده‌اند تا اطمینان حاصل شود که کارکنان ما می‌توانند تعادل سالمی بین
          کار و زندگی شخصی خود داشته باشند، استرس را کاهش دهند و رضایت شغلی را
          افزایش دهند.
        </p>
        <img
          src="/work (2).jpg"
          className="w-full  object-cover my-8 rounded-[10px] center"
          alt=""
        />
      </div>
      <ContactWays data={props?.dealerData} />
    </div>
  );
};

export default WorkWithUsPage;
